export default __webpack_public_path__ + "static/media/yes.89fccd9b.svg";